import React from "react";

/**
 * Creates a filled star icon with the specified class name.
 *
 * @param {string} cls - The class name for the icon
 * @return {JSX.Element} The filled star icon component
 */
export const StarFilledIcon = ({ cls = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      className={cls}
    >
      <path
        d="M3.98935 12.8121L6.66082 14.8266L5.64626 18.0708C5.4823 18.5739 5.48022 19.1183 5.64034 19.6228C5.80045 20.1272 6.11417 20.5648 6.53475 20.8702C6.94811 21.1853 7.44904 21.3542 7.9629 21.3515C8.47675 21.3489 8.97602 21.1749 9.38631 20.8554L11.9985 18.8704L14.6114 20.8531C15.0241 21.1665 15.5223 21.3367 16.0345 21.3393C16.5467 21.3419 17.0465 21.1767 17.4621 20.8675C17.8776 20.5582 18.1875 20.1209 18.3472 19.6184C18.5069 19.1159 18.5081 18.574 18.3507 18.0708L17.3362 14.8266L20.0077 12.8121C20.4197 12.501 20.7261 12.0634 20.8829 11.5618C21.0397 11.0602 21.039 10.5203 20.8809 10.0192C20.7228 9.51801 20.4153 9.08128 20.0024 8.77134C19.5895 8.46139 19.0923 8.2941 18.5819 8.29335H15.3003L14.3045 5.08871C14.1479 4.58427 13.8402 4.14422 13.4258 3.83201C13.0113 3.5198 12.5115 3.35156 11.9985 3.35156C11.4855 3.35156 10.9857 3.5198 10.5712 3.83201C10.1568 4.14422 9.84908 4.58427 9.69248 5.08871L8.69668 8.29335H5.41813C4.90766 8.2941 4.41047 8.46139 3.99759 8.77134C3.5847 9.08128 3.27724 9.51801 3.11911 10.0192C2.96098 10.5203 2.96028 11.0602 3.11711 11.5618C3.27394 12.0634 3.58027 12.501 3.99235 12.8121H3.98935Z"
        fill="currentColor"
      />
    </svg>
  );
};
